import { createContext, useContext } from 'react'
import { useStoredState } from './storage.js'

// Miles or kilometres, chosen in the navbar and remembered per viewer. Miles by default, like
// the app.
const UnitContext = createContext(['mi', () => {}])

export function UnitProvider({ children }) {
  const state = useStoredState('units', 'mi')
  return <UnitContext.Provider value={state}>{children}</UnitContext.Provider>
}

export function useUnit() {
  return useContext(UnitContext)
}
